const WhatsApp = () => {
    return (
        <a
            href="https://wa.me/542995347581"
            className="whatsapp-flotante"
            target="_blank"
            rel="noopener noreferrer"
        >
            <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" />
        </a>
    );
};

export default WhatsApp;